/**
 * Exchange Controller Mapping
 * Maps exchange IDs to their corresponding API controllers
 */

const EXCHANGE_CONTROLLERS = {
  3: {
    name: 'Binance',
    exchangeId: 3,
    endpoints: {
      spot: '/api/binance-balance/:userId/spot',
      futures: '/api/binance-balance/:userId/futures',
      all: '/api/binance-balance/:userId/all'
    },
    supportedAccountTypes: ['spot', 'futures', 'all']
  },
  6: {
    name: 'Bitmart',
    exchangeId: 6,
    endpoints: {
      main: '/api/bitmart-balance/:userId/main',
      spot: '/api/bitmart-balance/:userId/spot',
      futures: '/api/bitmart-balance/:userId/futures',
      all: '/api/bitmart-balance/:userId/all'
    },
    supportedAccountTypes: ['main', 'spot', 'futures', 'all']
  },
  7: {
    name: 'Bitget',
    exchangeId: 7,
    endpoints: {
      spot: '/api/bitget-balance/:userId/spot',
      futures: '/api/bitget-balance/:userId/futures',
      all: '/api/bitget-balance/:userId/all'
    },
    supportedAccountTypes: ['spot', 'futures', 'all']
  },
  8: {
    name: 'Coinbase',
    exchangeId: 8,
    endpoints: {
      spot: '/api/coinbase-balance/:userId/spot',
      futures: '/api/coinbase-balance/:userId/futures',
      all: '/api/coinbase-balance/:userId/all'
    },
    supportedAccountTypes: ['spot', 'futures', 'all']
  },
  9: {
    name: 'BingX',
    exchangeId: 9,
    endpoints: {
      spot: '/api/bingx-balance/:userId/spot',
      futures: '/api/bingx-balance/:userId/futures',
      all: '/api/bingx-balance/:userId/all'
    },
    supportedAccountTypes: ['spot', 'futures', 'all']
  },
  12: {
    name: 'XT',
    exchangeId: 12,
    endpoints: {
      spot: '/api/xt-balance/:userId/spot',
      futures: '/api/xt-balance/:userId/futures',
      all: '/api/xt-balance/:userId/all'
    },
    supportedAccountTypes: ['spot', 'futures', 'all']
  },
  10: {
    name: 'CoinEx',
    exchangeId: 10,
    endpoints: {
      spot: '/api/coinex-balance/:userId/spot',
      futures: '/api/coinex-balance/:userId/futures',
      all: '/api/coinex-balance/:userId/all'
    },
    supportedAccountTypes: ['spot', 'futures', 'all']
  },
  11: {
    name: 'HTX',
    exchangeId: 11,
    endpoints: {
      spot: '/api/htx-balance/:userId/spot',
      futures: '/api/htx-balance/:userId/futures',
      all: '/api/htx-balance/:userId/all'
    },
    supportedAccountTypes: ['spot', 'futures', 'all']
  },
  5: {
    name: 'LBank',
    exchangeId: 5,
    endpoints: {
      spot: '/api/lbank-balance/:userId/spot',
      futures: '/api/lbank-balance/:userId/futures',
      all: '/api/lbank-balance/:userId/all'
    },
    supportedAccountTypes: ['spot', 'all']
  },
  13: {
    name: 'KuCoin',
    exchangeId: 13,
    endpoints: {
      spot: '/api/kucoin-balance/:userId/spot',
      futures: '/api/kucoin-balance/:userId/futures',
      all: '/api/kucoin-balance/:userId/all'
    },
    supportedAccountTypes: ['spot', 'futures', 'all']
  },
  14: {
    name: 'OKX',
    exchangeId: 14,
    endpoints: {
      spot: '/api/okx-balance/:userId/spot',
      futures: '/api/okx-balance/:userId/futures',
      all: '/api/okx-balance/:userId/all'
    },
    supportedAccountTypes: ['spot', 'futures', 'all']
  },
  15: {
    name: 'Kraken',
    exchangeId: 15,
    endpoints: {
      spot: '/api/kraken-balance/:userId/spot',
      futures: '/api/kraken-balance/:userId/futures',
      all: '/api/kraken-balance/:userId/all'
    },
    supportedAccountTypes: ['spot', 'futures', 'all']
  },
  4: {
    name: 'MEXC',
    exchangeId: 4,
    endpoints: {
      spot: '/api/mexc-balance/:userId/spot',
      futures: '/api/mexc-balance/:userId/futures',
      all: '/api/mexc-balance/:userId/all'
    },
    supportedAccountTypes: ['spot', 'futures', 'all']
  }
  // Add more exchanges here as they are implemented
};

/**
 * Get controller config for an exchange
 * @param {number} exchangeId - The exchange ID
 * @returns {object|null} - Controller config or null if not found
 */
export function getExchangeController(exchangeId) {
  return EXCHANGE_CONTROLLERS[exchangeId] || null;
}

/**
 * Check if an exchange has a controller implemented
 * @param {number} exchangeId - The exchange ID
 * @returns {boolean}
 */
export function hasExchangeController(exchangeId) {
  return exchangeId in EXCHANGE_CONTROLLERS;
}

/**
 * Get all supported exchanges
 * @returns {array} - Array of exchange configs
 */
export function getAllSupportedExchanges() {
  return Object.values(EXCHANGE_CONTROLLERS);
}

export default EXCHANGE_CONTROLLERS;
